/* eslint-disable */
export default {
  callerCall: 'Persona que llama',
  transferCall: 'Transferir',
} as const;

// @key: @#@"callerCall"@#@ @source: @#@"Caller"@#@
// @key: @#@"transferCall"@#@ @source: @#@"Transfer"@#@
